export const common = {
  langs: ['es', 'ca'],
  defaultLang: 'ca',
  mock: false,

  urlContactoLogin: 'http://www.preinscripcion.gva.es/',
  urlAyudaIdesp: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaIDESP_IXESPcas.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AjudaIDESP_IXESPval.pdf'
  },
  urlAyudaTramitadorAcceso: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoCAS_breve.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoVAL_breve.pdf'
  },
  urlAyudaTramitadorAccesoDet: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoCAS_det.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoVAL_det.pdf'
  },
  urlAyudaPriuni: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/ManualAsistenteSolicitud_cas.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/ManualAsistenteSolicitud_val.pdf'
  },
  urlAyudaCondEspeciales: 'http://tramitadoredudesa.gva.es:8008/tel/assets/GradosCondicionesEspeciales.pdf',
  urlAyudaDocRequerida: 'http://tramitadoredudesa.gva.es:8008/tel/assets/DocumentacionRequerida.pdf'
};
